<template>
  <div class="yx-blsx-page main-layout">
    <CCollapseItem>
      <template slot="title-left"> 现场办理事项情况 </template>
      <template slot="body">
        <c-search
          v-model="pageParams"
          :searchItems="searchItems"
          @reset="refresh"
          @search="pageGet(true)"
        >
        </c-search>
      </template>
    </CCollapseItem>
    <el-card class="box-table box-bottom">
      <div slot="header" class="btn-group">
        <!-- 操作按钮 -->
        <div class="btn-left">
          <!-- <el-button type="primary" plain>导出</el-button> -->
        </div>
        <!-- 右侧操作按钮 -->
        <table-btns
          :tableColumns="tableColumns"
          @tableColumnsChange="tableColumnsChange"
          @refresh="pageGet(true)"
        ></table-btns>
      </div>
      <div class="div-scroll">
        <c-table
          :data="pageData"
          :tableColumns="tableColumns"
          :pagination="pageParams"
          @change="pageGet"
          @selectionChange="selectionChange"
          v-loading="pageLoading"
        >
        </c-table>
      </div>
    </el-card>
  </div>
</template>

<script>
import MPage from "@/mixins/MPage.js";
import MExcel from "@/mixins/MExcel.js";
import Configs from "./data/blsx";
import CSearch from "@/components/CSearch/index.vue";
import CTable from "@/components/CTable/index.vue";
import TableBtns from "@/components/TableBtns/index.vue";
import { getOrgOptions, getLinkOptions } from "@/libs/searchSelect.js";
let mPage = MPage({
  // pagePath: "/welcome-live/statistics/oneLinkListPage",
  pagePath: "",
  pageDelPath: "",
  pageDelsPath: "",
  pageParams: {
    idCard: "",
    studentName: "",
    link: "",
    status: "",
    collegeId: "",
    departmentId: "",
    majorId: "",
    classId: "",
  },
});
export default {
  mixins: [mPage],
  name: "",
  components: { CSearch, CTable, TableBtns },
  data() {
    let { searchItems, tableColumns } = Configs(this);
    return {
      isFold: false,
      searchItems,
      tableColumns,
      idList: [],
    };
  },
  created() {
    getOrgOptions(this, { type: "college" }, 4, null);
    getLinkOptions(this, 2, null);
  },
  mounted() {},
  methods: {
    selectionChange(data) {
      let idList = [];
      if (data.length) {
        data.forEach((item) => {
          idList.push(item.id);
        });
        this.idList = idList;
      }
    },
    handleDelBatch() {
      if (this.idList.length) {
        this.pageDels(this.idList);
      } else {
        this.$message({
          message: "请选择需要删除的数据！",
          type: "warning",
        });
      }
    },
    pageDelAfterFn() {
      this.idList = [];
      this.pageGet(true);
    },
    refresh() {
      this.searchItems[5].options = [];
      this.searchItems[6].options = [];
      this.searchItems[7].options = [];
      this.pageParams = {
        idCard: "",
        studentName: "",
        linkId: "",
        status: "",
        collegeId: "",
        departmentId: "",
        majorId: "",
        classId: "",
      };
      this.pageGet(true);
    },
    tableColumnsChange(data) {
      let self = this;
      self.tableColumns.forEach((item) => {
        if (data.indexOf(item.prop) == -1) {
          item.show = false;
        } else {
          item.show = true;
        }
      });
    },
  },
};
</script>
